import axiosServer from '@/configs/axiosServer'

const voucher = {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    async redeemVoucher ({ rootState }, payloadData) {
      try {
        const { data } = await axiosServer({
          url: '/payment/voucher_redeem/',
          method: 'POST',
          headers: {
            Authorization: rootState.storage.accessToken
          },
          data: payloadData,
          generateQueryParamSource: true
        })
        return data
      } catch (error) {
        return {
          status: 500,
          message: error.response.data.message
        }
      }
    }
  }
}

export default voucher
